

import moment from "moment";
function DisplayPunchInSession({ punchBreakDown,
    handlePunchOutData,
    handlePunchInData
}) {

    const calculateSessionHours = (inTime, outTime) => {
        if (!inTime || !outTime) return '-';
        const start = moment(inTime, "hh:mm A");
        const end = moment(outTime, "hh:mm A");
        if (!start.isValid() || !end.isValid()) return '-';
        const diff = moment.duration(end.diff(start));
        const hours = Math.floor(diff.asHours());
        const minutes = diff.minutes();
        if (hours < 0) return '-';
        return `${hours}h ${minutes}m`;
    };

    return (
        <tr>
            <td colSpan={8} style={{ padding: '0 16px 12px 48px', backgroundColor: 'transparent' }}>
                <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    padding: '14px 18px',
                    boxShadow: '0 2px 8px rgba(83,183,232,0.08)',
                    border: '1px solid #ddeaf3',
                }}>
                    <div style={{ color: '#53B7E8', fontWeight: 700, fontSize: '13px', marginBottom: '12px', letterSpacing: '0.3px' }}>
                        Punch Breakdown
                    </div>

                    <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 6px' }}>
                        <thead>
                            <tr>
                                {['Session Number', 'Punch In', "Check In Location", 'Punch Out', 'Check Out Location', 'Session Hours'].map((h, i) => (
                                    <th key={i} style={{
                                        backgroundColor: '#EEF8FD',
                                        color: '#333',
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        padding: '8px 14px',
                                        textAlign: 'left',
                                        borderRadius: i === 0 ? '8px 0 0 8px' : i === 3 ? '0 8px 8px 0' : '0',
                                    }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {punchBreakDown?.length > 0 ? (
                                punchBreakDown?.map((punch, i) => (
                                    <tr key={i}>
                                        <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444', fontWeight: 500 }}>{i + 1}</td>
                                        <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444' }}>{punch.InTime || '-'}</td>
                                        <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444' }}
                                            onClick={() => handlePunchInData(punch)}
                                        >{punch.InTimeLocation || '-'}</td>
                                        <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444' }}>{punch.OutTime || '-'}</td>
                                        <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444' }}
                                            onClick={() => handlePunchOutData(punch)}
                                        >{punch.OutTimeLocation || '-'}</td>
                                        <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444' }}>{calculateSessionHours(punch?.InTime, punch?.OutTime)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} style={{ padding: '10px 14px', fontSize: '12px', color: '#828282', textAlign: 'center' }}>
                                        No punch records found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </div>
            </td>
        </tr>
    );

}

export default DisplayPunchInSession;